import { render } from "./PwdPending.vue?vue&type=template&id=127ca7fc"
import script from "./PwdPending.vue?vue&type=script&lang=js"
export * from "./PwdPending.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__